import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import LanguageContext from "../../i18n/LanguageContext";

class BannerV2 extends Component {
  render() {
    const { t } = this.context;
    let publicUrl = process.env.PUBLIC_URL + "/";
    let imagealt = "image";

    return (
      <div className="ltn__slider-area ltn__slider-11  ltn__slider-11-slide-item-count-show--- ltn__slider-11-pagination-count-show--- section-bg-1">
        <div className="ltn__slider-11-inner">
          <div className="ltn__slider-11-active">
            {/* slide-item */}
            <div className="ltn__slide-item ltn__slide-item-2 ltn__slide-item-3-normal ltn__slide-item-3 ltn__slide-item-11">
              <div className="ltn__slide-item-inner">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 align-self-center">
                      <div className="slide-item-info">
                        <div className="slide-item-info-inner ltn__slide-animation">
                          <h6 className="slide-sub-title white-color--- animated">
                            <span>
                              <i className="fas fa-home" />
                            </span>{" "}
                            {t("banner.subtitle")}
                          </h6>
                          <h1 className="slide-title animated ">
                            {t("banner.slide1Title")}
                          </h1>
                          <div className="slide-brief animated">
                            <p>{parse(t("banner.slide1Text"))}</p>
                          </div>
                          <div className="btn-wrapper animated">
                            <a
                              href="https://api.whatsapp.com/send?phone=905520721972"
                              className="theme-btn-1 btn btn-effect-1"
                            >
                              {t("banner.reserve")}
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="slide-item-img">
                        <img src={publicUrl + "assets/img/3.png"} alt="#" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* slide-item */}
            <div className="ltn__slide-item ltn__slide-item-2 ltn__slide-item-3-normal ltn__slide-item-3 ltn__slide-item-11">
              <div className="ltn__slide-item-inner">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 align-self-center">
                      <div className="slide-item-info">
                        <div className="slide-item-info-inner ltn__slide-animation">
                          <div className="slide-video mb-50 d-none">
                            <a
                              className="ltn__video-icon-2 ltn__video-icon-2-border"
                              href=""
                              data-rel="lightcase:myCollection"
                            >
                              <i className="fa fa-play" />
                            </a>
                          </div>
                          <h6 className="slide-sub-title white-color--- animated">
                            <span>
                              <i className="fas fa-home" />
                            </span>{" "}
                            {t("banner.subtitle")}
                          </h6>
                          <h1 className="slide-title animated ">
                            {parse(t("banner.slide2Title"))}
                          </h1>
                          <div className="slide-brief animated">
                            <p>{parse(t("banner.slide2Text"))}</p>
                          </div>
                          <div className="btn-wrapper animated">
                            <Link
                              to="/portfolio"
                              className="theme-btn-1 btn btn-effect-1"
                            >
                              {t("banner.photos")}
                            </Link>
                            <Link
                              to="/contact"
                              className="btn btn-transparent btn-effect-3"
                            >
                              {t("banner.contact")}
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="slide-item-img">
                        <img src={publicUrl + "assets/img/4.png"} alt="#" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* slide-item */}
            <div className="ltn__slide-item ltn__slide-item-2 ltn__slide-item-3-normal ltn__slide-item-3 ltn__slide-item-11">
              <div className="ltn__slide-item-inner">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 align-self-center">
                      <div className="slide-item-info">
                        <div className="slide-item-info-inner ltn__slide-animation">
                          <h6 className="slide-sub-title white-color--- animated">
                            <span>
                              <i className="fas fa-home" />
                            </span>{" "}
                            {t("banner.subtitle")}
                          </h6>
                          <h1 className="slide-title animated ">
                            {t("banner.slide3Title")}
                          </h1>
                          <div className="slide-brief animated">
                            <p>{t("banner.slide3Text")}</p>
                          </div>
                          <div className="btn-wrapper animated">
                            <a
                              href="https://api.whatsapp.com/send?phone=905520721972"
                              className="theme-btn-1 btn btn-effect-1"
                            >
                              {t("banner.reserve")}
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="slide-item-img" sty>
                        <img src={publicUrl + "assets/img/27.png"} alt="#" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* slide-item */}
          </div>
          {/* slider-4-pagination */}
          <div className="ltn__slider-11-pagination-count">
            <span className="count" />
            <span className="total" />
          </div>
          {/* slider-sticky-icon */}
          <div className="slider-sticky-icon-2">
            <ul>
              <li>
                <a href="#" title="Facebook">
                  <i className="fab fa-facebook-f" />
                </a>
              </li>
              <li>
                <a href="#" title="Twitter">
                  <i className="fab fa-twitter" />
                </a>
              </li>
              <li>
                <a href="#" title="Linkedin">
                  <i className="fab fa-linkedin" />
                </a>
              </li>
            </ul>
          </div>
          {/* slider-4-img-slide-arrow */}
          <div className="ltn__slider-11-img-slide-arrow">
            <div className="ltn__slider-11-img-slide-arrow-inner">
              <div className="ltn__slider-11-img-slide-arrow-active">
                <div className="image-slide-item">
                  <img
                    src={publicUrl + "assets/img/3.png"}
                    alt="Flower Image"
                  />
                </div>
                <div className="image-slide-item">
                  <img
                    src={publicUrl + "assets/img/4.png"}
                    alt="Flower Image"
                  />
                </div>
                <div className="image-slide-item">
                  <img
                    src={publicUrl + "assets/img/27.jpg"}
                    alt="Flower Image"
                  />
                </div>
              </div>
              {/* slider-4-slide-item-count */}
              <div className="ltn__slider-11-slide-item-count">
                <span className="count" />
                <span className="total" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BannerV2.contextType = LanguageContext;

export default BannerV2;
